/**
 * Cambio de organización entre subdominios: localStorage es por origen, así que
 * `selectedClientId` guardado en `bubloud.dominio` no existe en `reepalais.dominio`.
 * Se añade `?clientId=` a la URL de destino y se hidrata aquí antes de montar React.
 */
export const CLIENT_SWITCH_URL_PARAM = 'clientId';

export function appendClientSwitchQuery(path: string, clientId: string): string {
  const enc = encodeURIComponent(clientId.trim());
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}${CLIENT_SWITCH_URL_PARAM}=${enc}`;
}

/**
 * Lee `clientId` de la query, escribe `selectedClientId` en localStorage del subdominio
 * actual y limpia el parámetro de la barra de dirección (sin recargar).
 */
export function hydrateActiveClientIdFromUrl(): void {
  try {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const cid = params.get(CLIENT_SWITCH_URL_PARAM)?.trim();
    if (!cid) return;
    if (cid.length < 8 || cid.length > 200) return;
    localStorage.setItem('selectedClientId', cid);
    params.delete(CLIENT_SWITCH_URL_PARAM);
    const newSearch = params.toString();
    const qs = newSearch ? `?${newSearch}` : '';
    const newUrl = `${window.location.pathname}${qs}${window.location.hash}`;
    window.history.replaceState({}, '', newUrl);
  } catch {
    /* private mode / disabled storage */
  }
}
